import { ExcelParsedProperties } from 'icreate/common/models/channel-config';
import {
    isBlank,
    MotorChannelType,
    MotorTypeStrings,
    ChannelTypeStrings,
    SimpleTypes,
    isAnalogSpecialTypeString,
} from 'icreate/common/models/channel-type';
import { systemChannelType } from 'icreate/common/models/system-channels';

const sheetColumn = {
    RowId: 'ID',
    FcuNo: 'Fcu no.',
    ChannelType: 'Channel type',
    ChannelTypeSimple: 'IN',
    Tag: 'Ch. no. (tag)',
    Name: 'Name',
    Status: 'Status',
    MeasurableRangeMin: 'Min',
    MeasurableRangeMax: 'Max',
    NormalRangeMin: 'Min',
    NormalRangeMax: 'Max',
    MeasurementUnit: 'Unit',
    Scale: 'Scale',
    FixedDigit: 'Fixed digit',

    InputDataFuInputAddressFuNo: 'No.',
    InputDataFuInputAddressSlotNo: 'Slot',
    InputDataFuInputAddressPin: 'Pin',
    InputDataFuInputAddressPinCount: 'Pin count',
    InputDataMemoryInputAddressAddress: 'Input address',
    InputDataMemoryInputAddressMask: 'Input mask',
    InputDataMiscDigitalInputFilter: 'Digital input filter',
    InputDataMiscHysteresis: 'Alarm recovery hysteresis (%)',

    OutputDataFuOutputAddressFuNo: 'No.',
    OutputDataFuOutputAddressSlotNo: 'Slot',
    OutputDataFuOutputAddressPin: 'Pin',
    OutputDataFuOutputAddressPinCount: 'Pin count',
    OutputDataMemoryOutputAddressAddress: 'Output address',
    OutputDataMemoryOutputAddressMask: 'Output mask',
    OutputDataMiscSetPoint: 'Set point',
    OutputDataMiscSignalType: 'Output signal type',
    OutputDataMiscSignalWidth: 'Signal width (msec)',
    OutputDataMiscHysteresisForOpen: 'Hysteresis for open (%)',
    OutputDataMiscHysteresisForClose: 'Hysteresis for close (%)',

    DigitalAlarmSettingEnable: 'Enable',
    DigitalAlarmSettingStatusStringContactOn: 'ON status',
    DigitalAlarmSettingStatusStringContactOff: 'OFF status',
    DigitalAlarmSettingAlarmGroupNo: 'EX',
    DigitalAlarmSettingReposeGroup1No: 'R1',
    DigitalAlarmSettingReposeGroup2No: 'R2',
    DigitalAlarmSettingDelayTimer: 'Delay (sec)',
    DigitalAlarmSettingNormalOpenFlag: 'NO',
    DigitalAlarmSettingAlarmLevel: 'Level',

    MotorChannelSettingEnable: 'Enable',
    MotorChannelSettingMotorType: 'Motor type',
    MotorChannelSettingStopStatusString: 'STOP status',
    MotorChannelSettingStbyStatusString: 'STBY status',
    MotorChannelSettingRunStatusString1: 'RUN status 1',
    MotorChannelSettingRunStatusString2: 'RUN status 2',
    MotorChannelSettingRunStatusString3: 'RUN status 3',
    MotorChannelSettingRunStatusString4: 'RUN status 4',
    MotorChannelSettingRunStatusString5: 'RUN status 5',
    MotorChannelSettingAlarmGroupNo: 'EX',
    MotorChannelSettingReposeGroup1No: 'R1',
    MotorChannelSettingReposeGroup2No: 'R2',
    MotorChannelSettingDelayTimer: 'Delay (sec)',
    MotorChannelSettingAlarmLevel: 'Level',

    AlarmSettingVeryHighEnable: 'Enable',
    AlarmSettingVeryHighStatusString: 'Status',
    AlarmSettingVeryHighSetPoint: 'Set point',
    AlarmSettingVeryHighAlarmGroupNo: 'EX',
    AlarmSettingVeryHighReposeGroup1No: 'R1',
    AlarmSettingVeryHighReposeGroup2No: 'R2',
    AlarmSettingVeryHighDelayTimer: 'Delay (sec)',
    AlarmSettingVeryHighAlarmLevel: 'Level',

    AlarmSettingHighEnable: 'Enable',
    AlarmSettingHighStatusString: 'Status',
    AlarmSettingHighSetPoint: 'Set point',
    AlarmSettingHighAlarmGroupNo: 'EX',
    AlarmSettingHighReposeGroup1No: 'R1',
    AlarmSettingHighReposeGroup2No: 'R2',
    AlarmSettingHighDelayTimer: 'Delay (sec)',
    AlarmSettingHighAlarmLevel: 'Level',

    AlarmSettingLowEnable: 'Enable',
    AlarmSettingLowStatusString: 'Status',
    AlarmSettingLowSetPoint: 'Set point',
    AlarmSettingLowAlarmGroupNo: 'EX',
    AlarmSettingLowReposeGroup1No: 'R1',
    AlarmSettingLowReposeGroup2No: 'R2',
    AlarmSettingLowDelayTimer: 'Delay (sec)',
    AlarmSettingLowAlarmLevel: 'Level',

    AlarmSettingVeryLowEnable: 'Enable',
    AlarmSettingVeryLowStatusString: 'Status',
    AlarmSettingVeryLowSetPoint: 'Set point',
    AlarmSettingVeryLowAlarmGroupNo: 'EX',
    AlarmSettingVeryLowReposeGroup1No: 'R1',
    AlarmSettingVeryLowReposeGroup2No: 'R2',
    AlarmSettingVeryLowDelayTimer: 'Delay (sec)',
    AlarmSettingVeryLowAlarmLevel: 'Level',

    AlarmSettingSensorFailEnable: 'Enable',
    AlarmSettingSensorFailStatusString: 'Status',
    AlarmSettingSensorFailAlarmGroupNo: 'EX',
    AlarmSettingSensorFailReposeGroup1No: 'R1',
    AlarmSettingSensorFailReposeGroup2No: 'R2',
    AlarmSettingSensorFailDelayTimer: 'Delay (sec)',
    AlarmSettingSensorFailAlarmLevel: 'Level',

    AlarmSettingFeedbackErrorEnable: 'Enable',
    AlarmSettingFeedbackErrorStatusString: 'Status',
    AlarmSettingFeedbackErrorSetPoint: 'Set point',
    AlarmSettingFeedbackErrorAlarmGroupNo: 'EX',
    AlarmSettingFeedbackErrorReposeGroup1No: 'R1',
    AlarmSettingFeedbackErrorReposeGroup2No: 'R2',
    AlarmSettingFeedbackErrorDelayTimer: 'Delay (sec)',
    AlarmSettingFeedbackErrorAlarmLevel: 'Level',

    SystemAlarmSettingEnable: 'Enable',
    SystemAlarmSettingStatusString1: 'Status 1',
    SystemAlarmSettingStatusString2: 'Status 2',
    SystemAlarmSettingStatusString3: 'Status 3',
    SystemAlarmSettingStatusString4: 'Status 4',
    SystemAlarmSettingStatusString5: 'Status 5',
    SystemAlarmSettingStatusString6: 'Status 6',
    SystemAlarmSettingStatusString7: 'Status 7',
    SystemAlarmSettingStatusString8: 'Status 8',
    SystemAlarmSettingStatusString9: 'Status 9',
    SystemAlarmSettingStatusString10: 'Status 10',
    SystemAlarmSettingStatusString11: 'Status 11',
    SystemAlarmSettingStatusString12: 'Status 12',
    SystemAlarmSettingStatusString13: 'Status 13',
    SystemAlarmSettingStatusString14: 'Status 14',
    SystemAlarmSettingStatusString15: 'Status 15',
    SystemAlarmSettingStatusString16: 'Status 16',
    SystemAlarmSettingAlarmGroupNo: 'EX',
    SystemAlarmSettingReposeGroup1No: 'R1',
    SystemAlarmSettingReposeGroup2No: 'R2',
    SystemAlarmSettingDelayTimer: 'Delay (sec)',
    SystemAlarmSettingAlarmLevel: 'Level',

    StandardNameId: 'Standard name id',
    Remarks: 'Remarks',
};

export const nestedHeaders = [
    [
        {
            title: '',
            colspan: 7,
        },
        {
            title: '',
            colspan: 2,
        },
        {
            title: '',
            colspan: 2,
        },
        {
            title: '',
            colspan: 3,
        },
        {
            title: 'Input',
            colspan: 8,
        },
        {
            title: 'Output',
            colspan: 11,
        },
        {
            title: 'Alarm settings',
            colspan: 9,
        },
        {
            title: 'Alarm settings',
            colspan: 14,
        },
        {
            title: 'Alarm settings',
            colspan: 8,
        },
        {
            title: 'Alarm settings',
            colspan: 8,
        },
        {
            title: 'Alarm settings',
            colspan: 8,
        },
        {
            title: 'Alarm settings',
            colspan: 8,
        },
        {
            title: 'Alarm settings',
            colspan: 7,
        },
        {
            title: 'Alarm settings',
            colspan: 8,
        },
        {
            title: 'Alarm settings',
            colspan: 22,
        },
        {
            title: '',
            colspan: 2,
        },
        {
            title: '',
            colspan: 2,
        },
    ],
    [
        {
            title: '',
            colspan: 7,
        },
        {
            title: 'Measurable range',
            colspan: 2,
        },
        {
            title: 'Normal range',
            colspan: 2,
        },
        {
            title: '',
            colspan: 3,
        },
        {
            title: 'FU',
            colspan: 4,
        },
        {
            title: 'Memory input',
            colspan: 2,
        },
        {
            title: 'Misc',
            colspan: 2,
        },
        {
            title: 'FU',
            colspan: 4,
        },
        {
            title: 'Memory output',
            colspan: 2,
        },
        {
            title: 'Misc',
            colspan: 5,
        },
        {
            title: 'Digital alarm settings',
            colspan: 9,
        },
        {
            title: 'Motor channel settings',
            colspan: 14,
        },
        {
            title: 'High-High',
            colspan: 8,
        },
        {
            title: 'High',
            colspan: 8,
        },
        {
            title: 'Low',
            colspan: 8,
        },
        {
            title: 'Low-Low',
            colspan: 8,
        },
        {
            title: 'Sensor failure',
            colspan: 7,
        },
        {
            title: 'Feedback',
            colspan: 8,
        },
        {
            title: 'System alarm',
            colspan: 22,
        },
        {
            title: '',
            colspan: 2,
        },
        {
            title: '',
            colspan: 2,
        },
    ],
];

const wideColumns = new Map([
    [sheetColumn.Name, 350],
    [sheetColumn.Status, 250],
    [sheetColumn.MeasurableRangeMin, 100],
    [sheetColumn.MeasurableRangeMax, 100],
    [sheetColumn.NormalRangeMin, 100],
    [sheetColumn.NormalRangeMax, 100],
    [sheetColumn.InputDataFuInputAddressPinCount, 80],
    [sheetColumn.OutputDataFuOutputAddressPinCount, 80],

    [sheetColumn.DigitalAlarmSettingAlarmLevel, 120],
    [sheetColumn.DigitalAlarmSettingNormalOpenFlag, 50],
    [sheetColumn.MotorChannelSettingAlarmLevel, 120],
    [sheetColumn.AlarmSettingVeryHighAlarmLevel, 120],
    [sheetColumn.AlarmSettingHighAlarmLevel, 120],
    [sheetColumn.AlarmSettingLowAlarmLevel, 120],
    [sheetColumn.AlarmSettingVeryLowAlarmLevel, 120],
    [sheetColumn.AlarmSettingFeedbackErrorAlarmLevel, 120],
    [sheetColumn.AlarmSettingSensorFailAlarmLevel, 120],
    [sheetColumn.SystemAlarmSettingAlarmLevel, 120],

    [sheetColumn.RowId, 120],
    [sheetColumn.ChannelType, 250],
    [sheetColumn.ChannelTypeSimple, 100],
    [sheetColumn.Remarks, 350],
]);

const leftColumns = new Set([sheetColumn.ChannelType, sheetColumn.Name, sheetColumn.Status]);

const checkBoxPropertySet = new Set([
    'DigitalAlarmSettingEnable',
    'DigitalAlarmSettingNormalOpenFlag',
    'MotorChannelSettingEnable',
    'AlarmSettingVeryHighEnable',
    'AlarmSettingHighEnable',
    'AlarmSettingLowEnable',
    'AlarmSettingVeryLowEnable',
    'AlarmSettingSensorFailEnable',
    'AlarmSettingFeedbackErrorEnable',
    'SystemAlarmSettingEnable',
]);

const dropdownPropertyMap = new Map([
    ['ChannelType', { dropdownSources: 'channelType' }],
    ['ChannelTypeSimple', { dropdownSources: 'simpleChannelType' }],
    ['OutputDataMiscSignalType', { dropdownSources: 'outputSignalType' }],
    ['DigitalAlarmSettingAlarmLevel', { dropdownSources: 'alarmLevel' }],
    ['MotorChannelSettingMotorType', { dropdownSources: 'motorChannelType' }],
    ['MotorChannelSettingAlarmLevel', { dropdownSources: 'alarmLevel' }],
    ['AlarmSettingVeryHighAlarmLevel', { dropdownSources: 'alarmLevel' }],
    ['AlarmSettingHighAlarmLevel', { dropdownSources: 'alarmLevel' }],
    ['AlarmSettingLowAlarmLevel', { dropdownSources: 'alarmLevel' }],
    ['AlarmSettingVeryLowAlarmLevel', { dropdownSources: 'alarmLevel' }],
    ['AlarmSettingSensorFailAlarmLevel', { dropdownSources: 'onlyAlarm' }],
    ['AlarmSettingFeedbackErrorAlarmLevel', { dropdownSources: 'alarmLevel' }],
    ['SystemAlarmSettingAlarmLevel', { dropdownSources: 'alarmLevel' }],
]);

export const dropdownSources = {
    channelType: Object.values(ChannelTypeStrings),

    simpleChannelType: Object.values(SimpleTypes),

    motorChannelType: [
        'RUN',
        'RUN-A',
        'RUN-B',
        'RUN-C',
        'RUN-D',
        'RUN-E',
        'RUN-F',
        'RUN-G',
        'RUN-H',
        'RUN-I',
        'RUN-J',
        'RUN-K',
    ],
    alarmLevel: ['Alarm', 'Warning', 'Caution'],
    outputSignalType: ['Continuous', 'Single'],
    onlyAlarm: ['Alarm'],
};

const dropdownFilter = function (instance, cell, c, r, source) {
    if (c == ChannelSheetCol.CHANNEL_TYPE) {
        const value = instance.jexcel.getValueFromCoords(c, r);
        if (value !== systemChannelType) return source.filter(type => type != systemChannelType);
        return [systemChannelType];
    } else if (c == ChannelSheetCol.SIMPLE_CHANNEL_TYPE) {
        const value = instance.jexcel.getValueFromCoords(c, r);
        if (value !== SimpleTypes.SYS) return source.filter(type => type != SimpleTypes.SYS);
        return [SimpleTypes.SYS];
    }
    return source;
};

export function generateColums() {
    let columns = [];
    let columnsKey = Object.keys(sheetColumn);

    for (let i = 0; i < columnsKey.length; i++) {
        if (checkBoxPropertySet.has(columnsKey[i])) {
            columns[i] = {
                type: 'checkbox',
                title: sheetColumn[columnsKey[i]],
                width: getColumnWidth(sheetColumn[columnsKey[i]], i),
                allowEmpty: true,
            };
        } else if (dropdownPropertyMap.has(columnsKey[i])) {
            let property = dropdownPropertyMap.get(columnsKey[i]);
            columns[i] = {
                type: 'dropdown',
                title: sheetColumn[columnsKey[i]],
                source: dropdownSources[property.dropdownSources],
                filter: dropdownFilter,
                align: leftColumns.has(sheetColumn[columnsKey[i]]) ? 'left' : 'center',
                width: getColumnWidth(sheetColumn[columnsKey[i]], i),
            };
        } else {
            columns[i] = {
                type: 'text',
                title: sheetColumn[columnsKey[i]],
                width: getColumnWidth(sheetColumn[columnsKey[i]], i),
                align: leftColumns.has(sheetColumn[columnsKey[i]]) ? 'left' : 'center',
                readOnly: sheetColumn[columnsKey[i]] == sheetColumn.RowId,
            };
        }
    }
    return columns;
}

function getColumnWidth(key: string, index: number) {
    if (wideColumns.has(key)) {
        if (key == sheetColumn.Status) {
            if (index == 5) return wideColumns.get(key);
            return 100;
        }
        return wideColumns.get(key);
    } else {
        if (key == 'EX' || key == 'R1' || key == 'R2') return 40;
        const normalWidth = key.length * 10;
        return normalWidth;
    }
}

export enum ChannelSheetCol {
    INDEX = 0,
    FCU_NO = 1,
    CHANNEL_TYPE = 2,
    SIMPLE_CHANNEL_TYPE = 3,
    CHANNEL_TAG = 4,
    CHANNEL_NAME = 5,
    STATUS = 6,
    MEASURABLE_MIN = 7,
    MEASURABLE_MAX = 8,
    NORMAL_MIN = 9,
    NORMAL_MAX = 10,
    UNIT = 11,
    SCALE = 12,
    FIXED_DIGIT = 13,

    INPUT_FU_NO = 14,
    INPUT_SLOT_NO = 15,
    INPUT_PIN = 16,
    PIN_COUNT = 17,
    INPUT_MEMORY_ADDRESS = 18,
    INPUT_MEMORY_MASK = 19,
    DIGITAL_INPUT_FILTER = 20,
    ALARM_RECOVERY_HYSTERESIS = 21,

    OUTPUT_FU_NO = 22,
    OUTPUT_SLOT_NO = 23,
    OUTPUT_PIN = 24,
    OUTPUT_PIN_COUNT = 25,
    OUTPUT_MEMORY_ADDRESS = 26,
    OUTPUT_MEMORY_MASK = 27,
    OUTPUT_SETPOINT = 28,
    OUTPUT_SIGNAL_TYPE = 29,
    SIGNAL_WIDTH = 30,
    OUTPUT_HYSTERESIS_OPEN = 31,
    OUTPUT_HYSTERESIS_CLOSE = 32,

    DIGITAL_ENABLE = 33,
    DIGITAL_ON = 34,
    DIGITAL_OFF = 35,
    DIGITAL_ALARM_GROUP_NO = 36,
    DIGITAL_REPOSE_GROUP1_NO = 37,
    DIGITAL_REPOSE_GROUP2_NO = 38,
    DIGITAL_DELAY = 39,
    NORMAL_OPEN = 40,
    DIGITAL_ALARM = 41,

    MOTOR_ENABLE = 42,
    MOTOR_TYPE = 43,
    STOP_STATUS = 44,
    STBY_STATUS = 45,
    RUN1_STATUS = 46,
    RUN2_STATUS = 47,
    RUN3_STATUS = 48,
    RUN4_STATUS = 49,
    RUN5_STATUS = 50,
    MOTOR_ALARM_GROUP_NO = 51,
    MOTOR_REPOSE_GROUP1_NO = 52,
    MOTOR_REPOSE_GROUP2_NO = 53,
    MOTOR_DELAY = 54,
    MOTOR_ALARM = 55,

    HH_ENABLE = 56,
    HH_STRING = 57,
    HH_SETPOINT = 58,
    HH_ALARM_GROUP_NO = 59,
    HH_REPOSE_GROUP1_NO = 60,
    HH_REPOSE_GROUP2_NO = 61,
    HH_DELAY = 62,
    HH_ALARM = 63,

    H_ENABLE = 64,
    H_STRING = 65,
    H_SETPOINT = 66,
    H_ALARM_GROUP_NO = 67,
    H_REPOSE_GROUP1_NO = 68,
    H_REPOSE_GROUP2_NO = 69,
    H_DELAY = 70,
    H_ALARM = 71,

    L_ENABLE = 72,
    L_STRING = 73,
    L_SETPOINT = 74,
    L_ALARM_GROUP_NO = 75,
    L_REPOSE_GROUP1_NO = 76,
    L_REPOSE_GROUP2_NO = 77,
    L_DELAY = 78,
    L_ALARM = 79,

    LL_ENABLE = 80,
    LL_STRING = 81,
    LL_SETPOINT = 82,
    LL_ALARM_GROUP_NO = 83,
    LL_REPOSE_GROUP1_NO = 84,
    LL_REPOSE_GROUP2_NO = 85,
    LL_DELAY = 86,
    LL_ALARM = 87,

    SENSOR_FAILURE_ENABLE = 88,
    SENSOR_FAILURE_STRING = 89,
    SENSOR_FAILURE_ALARM_GROUP_NO = 90,
    SENSOR_FAILURE_REPOSE_GROUP1_NO = 91,
    SENSOR_FAILURE_REPOSE_GROUP2_NO = 92,
    SENSOR_FAILURE_DELAY = 93,
    SENSOR_FAILURE_ALARM = 94,

    FEEDBACK_ERROR_ENABLE = 95,
    FEEDBACK_ERROR_STRING = 96,
    FEEDBACK_ERROR_SETPOINT = 97,
    FEEDBACK_ERROR_ALARM_GROUP_NO = 98,
    FEEDBACK_ERROR_REPOSE_GROUP1_NO = 99,
    FEEDBACK_ERROR_REPOSE_GROUP2_NO = 100,
    FEEDBACK_ERROR_DELAY = 101,
    FEEDBACK_ERROR_ALARM = 102,

    SYSTEM_ALARM_ENABLE = 103,
    SYSTEM_ALARM_STRING1 = 104,
    SYSTEM_ALARM_STRING2 = 105,
    SYSTEM_ALARM_STRING3 = 106,
    SYSTEM_ALARM_STRING4 = 107,
    SYSTEM_ALARM_STRING5 = 108,
    SYSTEM_ALARM_STRING6 = 109,
    SYSTEM_ALARM_STRING7 = 110,
    SYSTEM_ALARM_STRING8 = 111,
    SYSTEM_ALARM_STRING9 = 112,
    SYSTEM_ALARM_STRING10 = 113,
    SYSTEM_ALARM_STRING11 = 114,
    SYSTEM_ALARM_STRING12 = 115,
    SYSTEM_ALARM_STRING13 = 116,
    SYSTEM_ALARM_STRING14 = 117,
    SYSTEM_ALARM_STRING15 = 118,
    SYSTEM_ALARM_STRING16 = 119,
    SYSTEM_ALARM_GROUP_NO = 120,
    SYSTEM_ALARM_REPOSE_GROUP1_NO = 121,
    SYSTEM_ALARM_REPOSE_GROUP2_NO = 122,
    SYSTEM_ALARM_DELAY = 123,
    SYSTEM_ALARM_ALARM = 124,

    STANDARD_NAME_ID = 125,
    REMARKS = 126,
}

const measurementRangeColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.MEASURABLE_MIN,
    ChannelSheetCol.MEASURABLE_MAX,
]);

const normalRangeColSet: Set<ChannelSheetCol> = new Set([ChannelSheetCol.NORMAL_MIN, ChannelSheetCol.NORMAL_MAX]);

const fuColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.INPUT_FU_NO,
    ChannelSheetCol.INPUT_SLOT_NO,
    ChannelSheetCol.INPUT_PIN,
    ChannelSheetCol.PIN_COUNT,
]);

const inputAddress: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.INPUT_FU_NO,
    ChannelSheetCol.INPUT_SLOT_NO,
    ChannelSheetCol.INPUT_PIN,
    ChannelSheetCol.PIN_COUNT,
]);

const extraInputColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.DIGITAL_INPUT_FILTER,
    ChannelSheetCol.ALARM_RECOVERY_HYSTERESIS,
]);

const digitalInputColSet: Set<ChannelSheetCol> = new Set([ChannelSheetCol.DIGITAL_INPUT_FILTER]);

const histeresisInputColSet: Set<ChannelSheetCol> = new Set([ChannelSheetCol.ALARM_RECOVERY_HYSTERESIS]);

const outputFuSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.OUTPUT_FU_NO,
    ChannelSheetCol.OUTPUT_SLOT_NO,
    ChannelSheetCol.OUTPUT_PIN,
    ChannelSheetCol.OUTPUT_PIN_COUNT,
]);

const outputMiscColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.OUTPUT_SETPOINT,
    ChannelSheetCol.OUTPUT_SIGNAL_TYPE,
    ChannelSheetCol.SIGNAL_WIDTH,
    ChannelSheetCol.OUTPUT_HYSTERESIS_OPEN,
    ChannelSheetCol.OUTPUT_HYSTERESIS_CLOSE,
]);

const outputMiscWithoutSignalSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.OUTPUT_SETPOINT,
    ChannelSheetCol.OUTPUT_HYSTERESIS_OPEN,
    ChannelSheetCol.OUTPUT_HYSTERESIS_CLOSE,
]);

const digitalAlarmColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.DIGITAL_ENABLE,
    ChannelSheetCol.DIGITAL_ON,
    ChannelSheetCol.DIGITAL_OFF,
    ChannelSheetCol.DIGITAL_ALARM_GROUP_NO,
    ChannelSheetCol.DIGITAL_REPOSE_GROUP1_NO,
    ChannelSheetCol.DIGITAL_REPOSE_GROUP2_NO,
    ChannelSheetCol.DIGITAL_DELAY,
    ChannelSheetCol.NORMAL_OPEN,
    ChannelSheetCol.DIGITAL_ALARM,
]);

const motorChannelColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.MOTOR_ENABLE,
    ChannelSheetCol.MOTOR_TYPE,
    ChannelSheetCol.STOP_STATUS,
    ChannelSheetCol.STBY_STATUS,
    ChannelSheetCol.RUN1_STATUS,
    ChannelSheetCol.RUN2_STATUS,
    ChannelSheetCol.RUN3_STATUS,
    ChannelSheetCol.RUN4_STATUS,
    ChannelSheetCol.RUN5_STATUS,
    ChannelSheetCol.MOTOR_ALARM_GROUP_NO,
    ChannelSheetCol.MOTOR_REPOSE_GROUP1_NO,
    ChannelSheetCol.MOTOR_REPOSE_GROUP2_NO,
    ChannelSheetCol.MOTOR_DELAY,
    ChannelSheetCol.MOTOR_ALARM,
]);

const veryHighColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.HH_ENABLE,
    ChannelSheetCol.HH_STRING,
    ChannelSheetCol.HH_SETPOINT,
    ChannelSheetCol.HH_ALARM_GROUP_NO,
    ChannelSheetCol.HH_REPOSE_GROUP1_NO,
    ChannelSheetCol.HH_REPOSE_GROUP2_NO,
    ChannelSheetCol.HH_DELAY,
    ChannelSheetCol.HH_ALARM,
]);

const highColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.H_ENABLE,
    ChannelSheetCol.H_STRING,
    ChannelSheetCol.H_SETPOINT,
    ChannelSheetCol.H_ALARM_GROUP_NO,
    ChannelSheetCol.H_REPOSE_GROUP1_NO,
    ChannelSheetCol.H_REPOSE_GROUP2_NO,
    ChannelSheetCol.H_DELAY,
    ChannelSheetCol.H_ALARM,
]);

const lowColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.L_ENABLE,
    ChannelSheetCol.L_STRING,
    ChannelSheetCol.L_SETPOINT,
    ChannelSheetCol.L_ALARM_GROUP_NO,
    ChannelSheetCol.L_REPOSE_GROUP1_NO,
    ChannelSheetCol.L_REPOSE_GROUP2_NO,
    ChannelSheetCol.L_DELAY,
    ChannelSheetCol.L_ALARM,
]);

const lowColWithoutSetPoint: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.L_STRING,
    ChannelSheetCol.L_ALARM_GROUP_NO,
    ChannelSheetCol.L_REPOSE_GROUP1_NO,
    ChannelSheetCol.L_REPOSE_GROUP2_NO,
    ChannelSheetCol.L_DELAY,
    ChannelSheetCol.L_ALARM,
]);

const veryLowColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.LL_ENABLE,
    ChannelSheetCol.LL_STRING,
    ChannelSheetCol.LL_SETPOINT,
    ChannelSheetCol.LL_ALARM_GROUP_NO,
    ChannelSheetCol.LL_REPOSE_GROUP1_NO,
    ChannelSheetCol.LL_REPOSE_GROUP2_NO,
    ChannelSheetCol.LL_DELAY,
    ChannelSheetCol.LL_ALARM,
]);

const sensorFailColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.SENSOR_FAILURE_ENABLE,
    ChannelSheetCol.SENSOR_FAILURE_STRING,
    ChannelSheetCol.SENSOR_FAILURE_ALARM_GROUP_NO,
    ChannelSheetCol.SENSOR_FAILURE_REPOSE_GROUP1_NO,
    ChannelSheetCol.SENSOR_FAILURE_REPOSE_GROUP2_NO,
    ChannelSheetCol.SENSOR_FAILURE_DELAY,
    ChannelSheetCol.SENSOR_FAILURE_ALARM,
]);

const feedbackErrorColSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.FEEDBACK_ERROR_ENABLE,
    ChannelSheetCol.FEEDBACK_ERROR_STRING,
    ChannelSheetCol.FEEDBACK_ERROR_SETPOINT,
    ChannelSheetCol.FEEDBACK_ERROR_ALARM_GROUP_NO,
    ChannelSheetCol.FEEDBACK_ERROR_REPOSE_GROUP1_NO,
    ChannelSheetCol.FEEDBACK_ERROR_REPOSE_GROUP2_NO,
    ChannelSheetCol.FEEDBACK_ERROR_DELAY,
    ChannelSheetCol.FEEDBACK_ERROR_ALARM,
]);

const systemSettingsColSet: Set<ChannelSheetCol> = new Set(
    Array.from({ length: 22 }, (_, i) => (i + ChannelSheetCol.SYSTEM_ALARM_ENABLE) as ChannelSheetCol)
);

const motorStatusCols: Set<number> = new Set([
    ChannelSheetCol.STOP_STATUS,
    ChannelSheetCol.STBY_STATUS,
    ChannelSheetCol.RUN1_STATUS,
    ChannelSheetCol.RUN2_STATUS,
    ChannelSheetCol.RUN3_STATUS,
    ChannelSheetCol.RUN4_STATUS,
    ChannelSheetCol.RUN5_STATUS,
]);

const motorAlarmCols: Set<number> = new Set([
    ChannelSheetCol.MOTOR_ALARM_GROUP_NO,
    ChannelSheetCol.MOTOR_REPOSE_GROUP1_NO,
    ChannelSheetCol.MOTOR_REPOSE_GROUP2_NO,
    ChannelSheetCol.MOTOR_DELAY,
    ChannelSheetCol.MOTOR_ALARM,
]);

const simpleViewSet: Set<ChannelSheetCol> = new Set([
    ChannelSheetCol.FCU_NO,
    ChannelSheetCol.SIMPLE_CHANNEL_TYPE,
    ChannelSheetCol.CHANNEL_TAG,
    ChannelSheetCol.CHANNEL_NAME,
    ChannelSheetCol.STATUS,
    ChannelSheetCol.MEASURABLE_MIN,
    ChannelSheetCol.MEASURABLE_MAX,
    ChannelSheetCol.UNIT,
]);

export const simpleViewColumnsSet: Set<number> = new Set([
    ...simpleViewSet,
    ...inputAddress,
    ...digitalAlarmColSet,
    ...motorChannelColSet,
    ...veryHighColSet,
    ...highColSet,
    ...lowColSet,
    ...veryLowColSet,
    ...sensorFailColSet,
]);

export function isAlarmPanelSyncCol(colIndex: ChannelSheetCol): boolean {
    return (
        (colIndex >= ChannelSheetCol.HH_ENABLE && colIndex <= ChannelSheetCol.FEEDBACK_ERROR_ALARM) ||
        digitalAlarmColSet.has(colIndex)
    );
}

export const contactStatusColSet: Set<number> = new Set([ChannelSheetCol.DIGITAL_ON, ChannelSheetCol.DIGITAL_OFF]);

export const leadingZeroNumericColSet: Set<number> = new Set([
    ChannelSheetCol.MEASURABLE_MIN,
    ChannelSheetCol.MEASURABLE_MAX,
    ChannelSheetCol.NORMAL_MIN,
    ChannelSheetCol.NORMAL_MAX,
    ChannelSheetCol.INPUT_FU_NO,
    ChannelSheetCol.INPUT_SLOT_NO,
    ChannelSheetCol.INPUT_PIN,
    ChannelSheetCol.PIN_COUNT,
    ChannelSheetCol.OUTPUT_FU_NO,
    ChannelSheetCol.OUTPUT_SLOT_NO,
    ChannelSheetCol.OUTPUT_PIN,
    ChannelSheetCol.OUTPUT_PIN_COUNT,
    ChannelSheetCol.OUTPUT_SETPOINT,
    ChannelSheetCol.DIGITAL_ALARM_GROUP_NO,
    ChannelSheetCol.DIGITAL_REPOSE_GROUP1_NO,
    ChannelSheetCol.DIGITAL_REPOSE_GROUP2_NO,
    ChannelSheetCol.DIGITAL_DELAY,
    ChannelSheetCol.MOTOR_ALARM_GROUP_NO,
    ChannelSheetCol.MOTOR_REPOSE_GROUP1_NO,
    ChannelSheetCol.MOTOR_REPOSE_GROUP2_NO,
    ChannelSheetCol.MOTOR_DELAY,
    ChannelSheetCol.HH_SETPOINT,
    ChannelSheetCol.HH_ALARM_GROUP_NO,
    ChannelSheetCol.HH_REPOSE_GROUP1_NO,
    ChannelSheetCol.HH_REPOSE_GROUP2_NO,
    ChannelSheetCol.HH_DELAY,
    ChannelSheetCol.H_SETPOINT,
    ChannelSheetCol.H_ALARM_GROUP_NO,
    ChannelSheetCol.H_REPOSE_GROUP1_NO,
    ChannelSheetCol.H_REPOSE_GROUP2_NO,
    ChannelSheetCol.H_DELAY,
    ChannelSheetCol.L_SETPOINT,
    ChannelSheetCol.L_ALARM_GROUP_NO,
    ChannelSheetCol.L_REPOSE_GROUP1_NO,
    ChannelSheetCol.L_REPOSE_GROUP2_NO,
    ChannelSheetCol.L_DELAY,
    ChannelSheetCol.LL_SETPOINT,
    ChannelSheetCol.LL_ALARM_GROUP_NO,
    ChannelSheetCol.LL_REPOSE_GROUP1_NO,
    ChannelSheetCol.LL_REPOSE_GROUP2_NO,
    ChannelSheetCol.LL_DELAY,
    ChannelSheetCol.SENSOR_FAILURE_ALARM_GROUP_NO,
    ChannelSheetCol.SENSOR_FAILURE_REPOSE_GROUP1_NO,
    ChannelSheetCol.SENSOR_FAILURE_REPOSE_GROUP2_NO,
    ChannelSheetCol.SENSOR_FAILURE_DELAY,
    ChannelSheetCol.FEEDBACK_ERROR_SETPOINT,
    ChannelSheetCol.FEEDBACK_ERROR_ALARM_GROUP_NO,
    ChannelSheetCol.FEEDBACK_ERROR_REPOSE_GROUP1_NO,
    ChannelSheetCol.FEEDBACK_ERROR_REPOSE_GROUP2_NO,
    ChannelSheetCol.FEEDBACK_ERROR_DELAY,
    ChannelSheetCol.SYSTEM_ALARM_GROUP_NO,
    ChannelSheetCol.SYSTEM_ALARM_REPOSE_GROUP1_NO,
    ChannelSheetCol.SYSTEM_ALARM_REPOSE_GROUP2_NO,
    ChannelSheetCol.SYSTEM_ALARM_DELAY,
]);

export function normalizeLeadingZeros<T>(value: T): T | string {
    if (value == null) return value;
    const trimmed = String(value).trim();
    if (!/^-?\d*\.?\d+$/.test(trimmed)) return value;
    return trimmed.replace(/^(-?)0+(\d)/, '$1$2');
}

export const systemGroupSimpleColsSet: Set<number> = new Set([
    ChannelSheetCol.INDEX,
    ChannelSheetCol.FCU_NO,
    ChannelSheetCol.SIMPLE_CHANNEL_TYPE,
    ChannelSheetCol.CHANNEL_TAG,
    ChannelSheetCol.CHANNEL_NAME,
    ChannelSheetCol.STATUS,
    ...systemSettingsColSet,
]);

export let alarmCols = {
    'high-high': {
        key: 'high-high',
        enableCol: ChannelSheetCol.HH_ENABLE,
        colStart: 55,
        colEnd: 62,
    },
    high: {
        key: 'high',
        enableCol: ChannelSheetCol.H_ENABLE,
        colStart: 63,
        colEnd: 70,
    },
    low: {
        key: 'low',
        enableCol: ChannelSheetCol.L_ENABLE,
        colStart: 71,
        colEnd: 78,
    },
    'low-low': {
        key: 'low-low',
        enableCol: ChannelSheetCol.LL_ENABLE,
        colStart: 79,
        colEnd: 86,
    },
};

export enum RuleKeyType {
    ANALOG = 'Analog',
    ANALOG_SPECIAL = 'Analog special',
    DIGITAL_CONTACT = 'Digital',
    FLOW = 'Flow',
    RUNNING = 'Running',
    DIGITAL_MOTOR = 'Motor',
    EXH_MEAN = 'Exh gas mean',
    EXH_DEV = 'Exh gas dev',
}

export const ChannelTypeDisableRules: Record<string, Set<number>> = {
    [RuleKeyType.DIGITAL_MOTOR]: new Set([
        ...Array.from(measurementRangeColSet),
        ...Array.from(normalRangeColSet),
        ChannelSheetCol.UNIT,
        ChannelSheetCol.FIXED_DIGIT,
        ...Array.from(histeresisInputColSet),
        ...Array.from(outputMiscWithoutSignalSet),
        ...Array.from(measurementRangeColSet),
        ...Array.from(normalRangeColSet),
        ...Array.from(digitalAlarmColSet),
        ...Array.from(highColSet),
        ...Array.from(veryHighColSet),
        ...Array.from(lowColSet),
        ...Array.from(veryLowColSet),
        ...Array.from(sensorFailColSet),
        ChannelSheetCol.FEEDBACK_ERROR_SETPOINT,
        ChannelSheetCol.MOTOR_ENABLE,
    ]),

    [RuleKeyType.DIGITAL_CONTACT]: new Set([
        ...Array.from(measurementRangeColSet),
        ...Array.from(normalRangeColSet),
        ChannelSheetCol.UNIT,
        ChannelSheetCol.PIN_COUNT,
        ...Array.from(histeresisInputColSet),
        ...Array.from(outputFuSet),
        ...Array.from(outputMiscColSet),
        ...Array.from(motorChannelColSet),
        ...Array.from(veryHighColSet),
        ...Array.from(highColSet),
        ...Array.from(lowColSet),
        ...Array.from(veryLowColSet),
        ...Array.from(feedbackErrorColSet),
        ...Array.from(sensorFailColSet),
        ChannelSheetCol.FIXED_DIGIT,
    ]),

    [RuleKeyType.ANALOG]: new Set([
        ChannelSheetCol.PIN_COUNT,
        ...Array.from(digitalInputColSet),
        ...Array.from(outputFuSet),
        ...Array.from(outputMiscColSet),
        ...Array.from(digitalAlarmColSet),
        ...Array.from(motorChannelColSet),
        ...Array.from(feedbackErrorColSet),
    ]),

    [RuleKeyType.ANALOG_SPECIAL]: new Set([
        ChannelSheetCol.PIN_COUNT,
        ...Array.from(digitalInputColSet),
        ...Array.from(outputFuSet),
        ...Array.from(outputMiscColSet),
        ...Array.from(digitalAlarmColSet),
        ...Array.from(motorChannelColSet),
        ...Array.from(feedbackErrorColSet),
        ...Array.from(sensorFailColSet),
    ]),

    [RuleKeyType.EXH_DEV]: new Set([
        ...Array.from(normalRangeColSet),
        ChannelSheetCol.PIN_COUNT,
        ...Array.from(fuColSet),
        ...Array.from(digitalInputColSet),
        ...Array.from(outputFuSet),
        ...Array.from(outputMiscColSet),
        ...Array.from(digitalAlarmColSet),
        ...Array.from(motorChannelColSet),
        ...Array.from(sensorFailColSet),
        ...Array.from(feedbackErrorColSet),
    ]),

    [RuleKeyType.EXH_MEAN]: new Set([
        ...Array.from(normalRangeColSet),
        ...Array.from(fuColSet),
        ...Array.from(digitalInputColSet),
        ...Array.from(histeresisInputColSet),
        ...Array.from(outputFuSet),
        ...Array.from(outputMiscColSet),
        ...Array.from(digitalAlarmColSet),
        ...Array.from(motorChannelColSet),
        ...Array.from(veryHighColSet),
        ...Array.from(highColSet),
        ...Array.from(lowColWithoutSetPoint),
        ...Array.from(veryLowColSet),
        ...Array.from(sensorFailColSet),
        ...Array.from(feedbackErrorColSet),
        ...Array.from(extraInputColSet),
    ]),

    [RuleKeyType.RUNNING]: new Set([
        ChannelSheetCol.UNIT,
        ChannelSheetCol.PIN_COUNT,
        ...Array.from(measurementRangeColSet),
        ...Array.from(normalRangeColSet),
        ...Array.from(digitalInputColSet),
        ...Array.from(histeresisInputColSet),
        ...Array.from(outputFuSet),
        ...Array.from(outputMiscColSet),
        ...Array.from(digitalAlarmColSet),
        ...Array.from(motorChannelColSet),
        ...Array.from(lowColSet),
        ...Array.from(veryLowColSet),
        ...Array.from(sensorFailColSet),
        ...Array.from(feedbackErrorColSet),
    ]),

    [RuleKeyType.FLOW]: new Set([
        ChannelSheetCol.PIN_COUNT,
        ...Array.from(measurementRangeColSet),
        ...Array.from(normalRangeColSet),
        ...Array.from(histeresisInputColSet),
        ...Array.from(outputFuSet),
        ...Array.from(outputMiscColSet),
        ...Array.from(digitalAlarmColSet),
        ...Array.from(motorChannelColSet),
        ...Array.from(lowColSet),
        ...Array.from(veryLowColSet),
        ...Array.from(sensorFailColSet),
        ...Array.from(feedbackErrorColSet),
    ]),
};

export function normalizeChannelType(type: string): string {
    if (!type) return '';

    if (type.includes(RuleKeyType.DIGITAL_MOTOR)) return RuleKeyType.DIGITAL_MOTOR;
    if (type.includes(RuleKeyType.EXH_MEAN)) return RuleKeyType.EXH_MEAN;
    if (type.includes(RuleKeyType.EXH_DEV)) return RuleKeyType.EXH_DEV;

    if (type.startsWith(RuleKeyType.DIGITAL_CONTACT)) return RuleKeyType.DIGITAL_CONTACT;
    if (type.startsWith(RuleKeyType.ANALOG)) {
        if (isAnalogSpecialTypeString(type)) return RuleKeyType.ANALOG_SPECIAL;
        return RuleKeyType.ANALOG;
    }
    if (type.startsWith(RuleKeyType.FLOW)) return RuleKeyType.FLOW;
    if (type.startsWith(RuleKeyType.RUNNING)) return RuleKeyType.RUNNING;

    return type;
}

export function shouldDisableCell(channelRow: string[], channelType: string, colNumber: number): boolean {
    if (colNumber == ChannelSheetCol.STATUS) return true;
    if (colNumber == ChannelSheetCol.SCALE) return true;

    if (channelType.startsWith('System')) {
        if (
            !systemSettingsColSet.has(colNumber) &&
            colNumber != ChannelSheetCol.CHANNEL_NAME &&
            colNumber != ChannelSheetCol.STANDARD_NAME_ID &&
            colNumber != ChannelSheetCol.REMARKS
        ) {
            return true;
        }
        if (systemSettingsColSet.has(colNumber)) {
            if (colNumber === ChannelSheetCol.SYSTEM_ALARM_ENABLE) return true;
            if (!channelRow[ChannelSheetCol.SYSTEM_ALARM_ENABLE]) return true;
        }
    } else {
        if (systemSettingsColSet.has(colNumber)) return true;
    }

    if (colNumber == ChannelSheetCol.SIMPLE_CHANNEL_TYPE || colNumber == ChannelSheetCol.CHANNEL_TYPE) return false;

    if (isBlank(channelType)) return true;

    let ruleKey = normalizeChannelType(channelType);
    if (!ruleKey) {
        ruleKey = Object.keys(ChannelTypeDisableRules).find(key => channelType.startsWith(key)) || channelType;
    }

    const disableSet = ChannelTypeDisableRules[ruleKey];
    if (disableSet && disableSet.has(colNumber)) {
        return true;
    }

    if (ruleKey === RuleKeyType.DIGITAL_CONTACT && digitalAlarmColSet.has(colNumber)) {
        if (
            colNumber !== ChannelSheetCol.DIGITAL_ENABLE &&
            colNumber !== ChannelSheetCol.DIGITAL_ON &&
            colNumber !== ChannelSheetCol.DIGITAL_OFF &&
            colNumber !== ChannelSheetCol.NORMAL_OPEN
        ) {
            return !channelRow[ChannelSheetCol.DIGITAL_ENABLE];
        }
    }

    const isHighEnabled = !!channelRow[ChannelSheetCol.H_ENABLE];
    const isLowEnabled = !!channelRow[ChannelSheetCol.L_ENABLE];
    const isHHEnabled = !!channelRow[ChannelSheetCol.HH_ENABLE];
    const isLLEnabled = !!channelRow[ChannelSheetCol.LL_ENABLE];

    if (veryHighColSet.has(colNumber)) {
        if (!isHighEnabled) return true;
        return colNumber === ChannelSheetCol.HH_ENABLE ? false : !isHHEnabled;
    }

    if (highColSet.has(colNumber) && colNumber !== ChannelSheetCol.H_ENABLE) {
        return !isHighEnabled;
    }

    if (lowColSet.has(colNumber) && colNumber !== ChannelSheetCol.L_ENABLE) {
        if (channelType.includes('Dev') && lowColWithoutSetPoint.has(colNumber)) {
            return true;
        }
        return !isLowEnabled;
    }

    if (veryLowColSet.has(colNumber)) {
        if (channelType.includes('Mean')) return true;
        if (!isLowEnabled) return true;
        return colNumber === ChannelSheetCol.LL_ENABLE ? false : !isLLEnabled;
    }

    if (sensorFailColSet.has(colNumber) && colNumber !== ChannelSheetCol.SENSOR_FAILURE_ENABLE)
        return !channelRow[ChannelSheetCol.SENSOR_FAILURE_ENABLE];

    if (feedbackErrorColSet.has(colNumber) && colNumber !== ChannelSheetCol.FEEDBACK_ERROR_ENABLE)
        return !channelRow[ChannelSheetCol.FEEDBACK_ERROR_ENABLE];

    if (motorChannelColSet.has(colNumber)) {
        const motorStatusCols = new Set([
            ChannelSheetCol.STOP_STATUS,
            ChannelSheetCol.STBY_STATUS,
            ChannelSheetCol.RUN1_STATUS,
            ChannelSheetCol.RUN2_STATUS,
            ChannelSheetCol.RUN3_STATUS,
            ChannelSheetCol.RUN4_STATUS,
            ChannelSheetCol.RUN5_STATUS,
        ]);

        if (motorStatusCols.has(colNumber)) {
            const motorTypeStr = channelRow[ChannelSheetCol.MOTOR_ENABLE + 1];
            if (motorTypeStr) {
                const motorTypeEntry = Object.entries(MotorTypeStrings).find(([, str]) => str === motorTypeStr);
                if (motorTypeEntry) {
                    const enumVal = Number(motorTypeEntry[0]) as MotorChannelType;
                    const definition = motorRunDefinitions.find(([type]) => type === enumVal);
                    if (definition && definition[1][colNumber as ChannelSheetCol] === '') {
                        return true;
                    }
                }
            }
        }
    }

    return false;
}

export const ChannelTypeNotRemoveRules: Record<string, Set<number>> = {
    [RuleKeyType.EXH_DEV]: new Set([ChannelSheetCol.SCALE]),
    [RuleKeyType.EXH_MEAN]: new Set([ChannelSheetCol.SCALE]),
    [RuleKeyType.RUNNING]: new Set([ChannelSheetCol.UNIT, ...Array.from(measurementRangeColSet)]),
    [RuleKeyType.FLOW]: new Set([...Array.from(measurementRangeColSet)]),
};

type MotorAlarmSetting = Partial<Record<ChannelSheetCol, string>>;

function createMotorDefaults(overrides: Partial<MotorAlarmSetting>): MotorAlarmSetting {
    const motorCols = [
        ChannelSheetCol.PIN_COUNT,
        ChannelSheetCol.STOP_STATUS,
        ChannelSheetCol.STBY_STATUS,
        ChannelSheetCol.RUN1_STATUS,
        ChannelSheetCol.RUN2_STATUS,
        ChannelSheetCol.RUN3_STATUS,
        ChannelSheetCol.RUN4_STATUS,
        ChannelSheetCol.RUN5_STATUS,
    ] as const;

    return motorCols.reduce((acc, col) => ({ ...acc, [col]: overrides[col] ?? '' }), {} as MotorAlarmSetting);
}

export const motorRunDefinitions = [
    [
        MotorChannelType.RUN,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '2',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.RUN1_STATUS]: 'RUN',
        }),
    ],
    [
        MotorChannelType.RUN_A,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '3',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.STBY_STATUS]: 'ST/BY',
            [ChannelSheetCol.RUN1_STATUS]: 'RUN',
        }),
    ],
    [
        MotorChannelType.RUN_B,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '3',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.RUN1_STATUS]: 'RUN-H',
            [ChannelSheetCol.RUN2_STATUS]: 'RUN-L',
        }),
    ],
    [
        MotorChannelType.RUN_C,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '3',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.RUN1_STATUS]: 'EXHAUST',
            [ChannelSheetCol.RUN2_STATUS]: 'SUPPLY',
        }),
    ],
    [
        MotorChannelType.RUN_D,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '5',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.RUN1_STATUS]: 'EXHAUST-H',
            [ChannelSheetCol.RUN2_STATUS]: 'EXHAUST-L',
            [ChannelSheetCol.RUN3_STATUS]: 'SUPPLY-H',
            [ChannelSheetCol.RUN4_STATUS]: 'SUPPLY-L',
        }),
    ],
    [
        MotorChannelType.RUN_E,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '3',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.RUN1_STATUS]: 'REVERSE',
            [ChannelSheetCol.RUN2_STATUS]: 'FORWARD',
        }),
    ],
    [
        MotorChannelType.RUN_F,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '5',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.RUN1_STATUS]: 'REVERSE-H',
            [ChannelSheetCol.RUN2_STATUS]: 'REVERSE-L',
            [ChannelSheetCol.RUN3_STATUS]: 'FORWARD-H',
            [ChannelSheetCol.RUN4_STATUS]: 'FORWARD-L',
        }),
    ],
    [
        MotorChannelType.RUN_G,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '2',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.RUN1_STATUS]: 'AUTO',
        }),
    ],
    [
        MotorChannelType.RUN_H,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '3',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.STBY_STATUS]: 'AUTO',
            [ChannelSheetCol.RUN1_STATUS]: 'RUN',
        }),
    ],
    [
        MotorChannelType.RUN_I,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '3',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.STBY_STATUS]: 'ST/BY',
            [ChannelSheetCol.RUN1_STATUS]: 'AUTO',
        }),
    ],
    [
        MotorChannelType.RUN_J,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '4',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.STBY_STATUS]: 'ST/BY',
            [ChannelSheetCol.RUN1_STATUS]: 'RUN-H',
            [ChannelSheetCol.RUN2_STATUS]: 'RUN-L',
        }),
    ],
    [
        MotorChannelType.RUN_K,
        createMotorDefaults({
            [ChannelSheetCol.PIN_COUNT]: '4',
            [ChannelSheetCol.STOP_STATUS]: 'STOP',
            [ChannelSheetCol.STBY_STATUS]: 'ST/BY',
            [ChannelSheetCol.RUN1_STATUS]: 'BYPASS-RUN',
            [ChannelSheetCol.RUN2_STATUS]: 'ECO-RUN',
        }),
    ],
] as const;

export const motorDefinitionByTypeString = new Map<string, MotorAlarmSetting>(
    motorRunDefinitions.map(([type, defaults]) => [MotorTypeStrings[type], defaults])
);

export const getColumnTitle = (columnName: string) => {
    const colMin = Object.entries(ExcelParsedProperties)
        .filter(([key, value]) => value === columnName)
        .map(([key, value]) => key);
    return sheetColumn[colMin[0]];
};

export function clearByChannelType(
    row: string[],
    channelType: string,
    worksheets: any,
    rowIndex: number | string
): any[] {
    const normalizedType = normalizeChannelType(channelType);
    const disableSet = ChannelTypeDisableRules[normalizedType];
    if (!disableSet) return [];

    const notRemoveSet = ChannelTypeNotRemoveRules[normalizedType] ?? new Set<number>();
    const changedRecords: any[] = [];
    const rIndex = Number(rowIndex);

    for (const columnIndex of disableSet) {
        if (columnIndex === ChannelSheetCol.STATUS) continue;
        if (columnIndex === ChannelSheetCol.SCALE) continue;
        if (notRemoveSet.has(columnIndex)) continue;

        const oldValue = worksheets.getValueFromCoords(columnIndex, rIndex);
        if (oldValue === '' || oldValue === null || oldValue === undefined) {
            continue;
        }

        changedRecords.push({
            row: rIndex,
            col: columnIndex,
            x: columnIndex,
            y: rIndex,
            oldValue,
            newValue: '',
        });

        row[columnIndex] = '';

        worksheets.ignoreHistory = true;
        worksheets.setValueFromCoords(columnIndex, rIndex, '', true);
    }

    return changedRecords;
}
